import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { CustomModal, Btn, CustomRadioButton, CustomInputTextArea } from '../../../../../components'
import { showMessageBox } from '../../../../../store/actions/system.actions'

const DISPONIVEL_OPTIONS = [
  { label: 'SIM', value: true },
  { label: 'NÃO', value: false },
]

function ModalDisponivel({ dispatch, show, onClose, data, onSave, isBtnLoading }) {
  const [disponivel, setDisponivel] = useState(true)
  const [justificativa, setJustificativa] = useState('')

  useEffect(() => {
    if (show && data) {
      const isAvailable = data.available_to_transfer === 1 || data.available_to_transfer === true
      setDisponivel(isAvailable)
      setJustificativa(data.transfer_not_available_reason || '')
    }
  }, [show, data])

  const handleSave = () => {
    if (!disponivel && (!justificativa || justificativa.trim() === '')) {
      dispatch(showMessageBox(null, 'É obrigatório justificar o motivo da entrega não estar disponível para transferência'))
      return
    }
    onSave(data.delivery_id, disponivel, disponivel ? null : justificativa)
  }

  return (
    <CustomModal
      header="Disponível para Transferência"
      isVisible={show}
      onClose={onClose}
      width={480}
    >
      <div>
        <p style={{ color: '#555', marginBottom: 12 }}>
          Essa entrega está disponível para ser transferida?
        </p>
        <CustomRadioButton
          items={DISPONIVEL_OPTIONS}
          value={disponivel}
          onChange={value => {
            setDisponivel(value)
            if (value) setJustificativa('')
          }}
          labelColor="#14B0BF"
          labelFontSize="0.9rem"
        />
        {!disponivel && (
          <CustomInputTextArea
            label="Justificativa"
            value={justificativa}
            onChange={setJustificativa}
            rows={4}
            marginTop={16}
          />
        )}
        <div style={{ marginTop: 20, textAlign: 'right' }}>
          <Btn onClick={handleSave} disabled={isBtnLoading}>
            {isBtnLoading ? 'Salvando...' : 'Salvar'}
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

const mapStateToProps = () => ({})
export default connect(mapStateToProps)(ModalDisponivel)
